import { unparseCurrency } from 'utils/parsers';
import { calculaFinanciamento } from 'utils/simuladorFin';

export const defaultProposalSimulation = {
  prazo_financiamento: 36,
  valor_venda: 'R$0',
  valor_financiamento: 'R$0',
  seguroSN: 'Sim',
  seguroAssisSN: 'Sim',
  tabSN: 0,
  carencia: 90,
  iofSN: 'Sim',
  tacSN: 0,
};

export const defaultTaxSimulation = {
  perc_seguro: '9.99',
  valor_seguro_assistencia: 99.9,
  perc_taxa: '2.39',
  perc_iof_pf: 0.0082,
  calculo_tac: 'fixo',
  valor_tac_fixo: 900,
};

/**
 * @param {React.FocusEvent<HTMLInputElement>} event
 * @param {(value: number) => void} setValue
 */
export const handleSimulatorPMT = (event, setNewValue) => {
  const value = event.target.value;
  if (unparseCurrency(value) === 0 || !value) {
    setNewValue(0);
    return;
  }

  const proposalSimulation = {
    ...defaultProposalSimulation,
    valor_venda: value,
    valor_financiamento: value,
  };
  const taxSimulation = defaultTaxSimulation;

  const financingValues = calculaFinanciamento(
    proposalSimulation,
    taxSimulation
  );

  setNewValue(financingValues.valorParcela);
};
